function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddFundVue from './AddFund.vue';
import FundDetails from './FundDetails.vue';
import { fundsRecordsApi } from '../api.js';
import { operationTypeEnum } from '../../enum';
export default {
  name: 'CapitalAllocation',
  components: {
    AddFundVue: AddFundVue,
    FundDetails: FundDetails
  },
  data: function data() {
    return {
      operationTypeEnum: operationTypeEnum,
      dialogFormVisible: false,
      AddFundVueRef: null,
      FundDetailsRef: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      form: {},
      tableData: {
        data: [],
        total: 100
      },
      pageConfig: {
        page: 1,
        limit: 15
      }
    };
  },
  methods: {
    open: function open(row) {
      this.form.customerId = row.id;
      this.getList();
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.pageConfig = {
        page: 1,
        limit: 15
      };
      this.dialogFormVisible = false;
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageConfig.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageConfig.page = page;
      this.getList();
    },
    search: function search() {
      this.pageConfig.page = 1;
      this.getList();
    },
    addFund: function addFund() {
      this.$refs.AddFundVueRef.open(this.form.customerId);
    },
    see: function see(id) {
      this.$refs.FundDetailsRef.open(id);
    },
    getList: function getList() {
      var _this = this;
      var params = _objectSpread(_objectSpread({}, this.pageConfig), this.form);
      if (params.operationTime) {
        params.operationTimeEnd = params.operationTime[1];
        params.operationTimeStart = params.operationTime[0];
        delete params.operationTime;
      }
      fundsRecordsApi(params).then(function (res) {
        _this.tableData = res;
      });
    }
  }
};